/*
 * Copyright (C) 2025.  SimpliCity Digital Inc - All Rights Reserved
 */

import { combineReducers } from "redux";
import { authCustomerReducer } from "cms/store/reducers/auth-customer";
import { orgSettingsReducer } from "cms/store/reducers/orgSettings";

const reducers = combineReducers({
    authCustomer: authCustomerReducer,
    orgSettings: orgSettingsReducer,
});

export default reducers;
